export default __webpack_public_path__ + "static/media/SSS.d60a2dea.png";